<template>
  <div>
    <section class="block-masthead border-bottom">
      <navigation theme="light" favourite-theme="dark"/>
      <template v-if="pageContent">
        <div class="row no-gutters">
          <div class="block col-md-6 d-flex align-items-center">
            <div class="content" data-aos="fade-up">
              <h1><span v-html="pageContent.title"></span></h1>
              <p>{{ pageContent.description }}</p>
            </div>
          </div>
          <div class="block contact-block col-md-6 d-flex align-items-center bg-dark">
            <div class="content" data-aos="fade-up">
              <h3>Email Us</h3>
              <a v-bind:href="'mailto:' + this.$root.store.contact_email">{{ this.$root.store.contact_email }}</a>
              <h3>Phone Us</h3>
              <a v-bind:href="'tel:' + this.$root.store.telephone_number">{{ this.$root.store.telephone_number }}</a>
            </div>
          </div>
        </div>
      </template>
    </section>
    <favourite-list/>
    <order-steps/>
    <site-footer/>
  </div>
</template>

<script>
  import OrderSteps from '@/components/OrderSteps'
  import SiteFooter from '@/components/SiteFooter'
  import Navigation from '@/components/Navigation'
  import FavouriteList from '@/components/FavouriteList'

  export default {
    name: 'ContactPage',
    components: {
      FavouriteList,
      SiteFooter,
      OrderSteps,
      Navigation
    },
    data() {
      return {
        globalContent: null,
        pageContent: null
      };
    },
    methods: {
      loadPageContent: function () {
        this.$root.$api.getPageBySlug('contact')
          .then(response => {
            if (response.data != null) {
              this.pageContent = response.data.pages[0];
              this.$refs.aboutContent.loadContent(this.pageContent.content[0]);
              this.$refs.supportingContent.loadContent(this.pageContent.content[1]);
            }
          }).catch(error => {
          console.log(error);
        })
      },
    },
    created: function () {
      this.loadPageContent();
    }
  };
</script>
